import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';

import { ThfDialogConfirmOptions, ThfDialogService, ThfNotificationService, ThfPageAction, ThfTableAction } from '@totvs/thf-ui';

import * as util from '../../utils/util';

import { ThfPageDynamicDetailComponent } from '../thf-page-dynamic-detail/thf-page-dynamic-detail.component';
// import { ThfPageDynamicEditComponent } from '../thf-page-dynamic-edit/thf-page-dynamic-edit.component';

import { ThfPageDynamicListBaseComponent } from './thf-page-dynamic-list-base.component';
import { ThfPageDynamicService } from './thf-page-dynamic.service';
import { ThfPageDynamicTableActions } from './thf-page-dynamic-table-actions.interface';

export const thfPageDynamicTableLiteralsDefault = {
  en: {
    pageAction: 'New',
    pageActionRemoveAll: 'Delete',
    tableActionView: 'View',
    tableActionEdit: 'Edit',
    tableActionDuplicate: 'Duplicate',
    tableActionDelete: 'Delete',
    confirmRemoveTitle: 'Confirm delete',
    confirmRemoveMessage: 'Are you sure you want to delete this record? You can not undo this action.',
    confirmRemoveAllTitle: 'Confirm batch deletion',
    confirmRemoveAllMessage: 'Are you sure you want to delete all these records? You can not undo this action.',
    loadDataErrorNotification: 'Service not found',
    removeSuccessNotification: 'Item deleted successfully',
    removeAllSuccessNotification: 'Items deleted successfully'
  },
  es: {
    pageAction: 'Nuevo',
    pageActionRemoveAll: 'Borrar',
    tableActionView: 'Visualizar',
    tableActionEdit: 'Editar',
    tableActionDuplicate: 'Duplicar',
    tableActionDelete: 'Borrar',
    confirmRemoveTitle: 'Confirmar la exclusiÃ³n',
    confirmRemoveMessage: 'Â¿EstÃ¡ seguro de que desea eliminar este registro? No puede deshacer esta acciÃ³n.',
    confirmRemoveAllTitle: 'Confirmar la exclusiÃ³n por lotes',
    confirmRemoveAllMessage: 'Â¿EstÃ¡ seguro de que desea eliminar todos estos registros? No puede deshacer esta acciÃ³n.',
    loadDataErrorNotification: 'Servicio no informado.',
    removeSuccessNotification: 'Elemento eliminado con Ã©xito',
    removeAllSuccessNotification: 'Elementos eliminados con Ã©xito'
  },
  pt: {
    pageAction: 'Novo',
    pageActionRemoveAll: 'Excluir',
    tableActionView: 'Visualizar',
    tableActionEdit: 'Editar',
    tableActionDuplicate: 'Duplicar',
    tableActionDelete: 'Excluir',
    confirmRemoveTitle: 'Confirmar exclusÃ£o',
    confirmRemoveMessage: 'Tem certeza de que deseja excluir esse registro? VocÃª nÃ£o poderÃ¡ desfazer essa aÃ§Ã£o.',
    confirmRemoveAllTitle: 'Confirmar exclusÃ£o em lote',
    confirmRemoveAllMessage: 'Tem certeza de que deseja excluir todos esses registros? VocÃª nÃ£o poderÃ¡ desfazer essa aÃ§Ã£o.',
    loadDataErrorNotification: 'ServiÃ§o nÃ£o informado.',
    removeSuccessNotification: 'Item excluido com sucesso',
    removeAllSuccessNotification: 'Items excluidos com sucesso'
  }
};

/**
 * @docsExtends ThfPageDynamicListBaseComponent
 *
 * @description
 *
 * O `thf-page-dynamic-table` Ã© uma pÃ¡gina que exibe uma lista de registros em uma tabela baseado em uma lista de fields,
 * o mesmo tambÃ©m suporta metadados conforme especificado na documentaÃ§Ã£o.
 *
 * @example
 *
 * <example name="thf-page-dynamic-table-basic" title="Totvs Page Dynamic Table Basic">
 *  <file name="sample-thf-page-dynamic-table-basic/sample-thf-page-dynamic-table-basic.component.html"> </file>
 *  <file name="sample-thf-page-dynamic-table-basic/sample-thf-page-dynamic-table-basic.component.ts"> </file>
 * </example>
 *
 * <example name="thf-page-dynamic-table-users" title="Totvs Page Dynamic Table - Users">
 *  <file name="sample-thf-page-dynamic-table-users/sample-thf-page-dynamic-table-users.component.html"> </file>
 *  <file name="sample-thf-page-dynamic-table-users/sample-thf-page-dynamic-table-users.component.ts"> </file>
 * </example>
 */
@Component({
  selector: 'thf-page-dynamic-table',
  templateUrl: './thf-page-dynamic-table.component.html',
  providers: [ ThfPageDynamicService ]
})
export class ThfPageDynamicTableComponent extends ThfPageDynamicListBaseComponent implements OnInit {

  private _actions: ThfPageDynamicTableActions = {};
  private _pageActions: Array<ThfPageAction> = [];
  private _tableActions: Array<ThfTableAction> = [];

  private page: number = 1;
  private params = {};

  hasNext = false;
  items = [];
  literals = {
    ...thfPageDynamicTableLiteralsDefault[util.thfLocaleDefault],
    ...thfPageDynamicTableLiteralsDefault[util.browserLanguage()]
  };

  /**
   * @optional
   *
   * @description
   *
   * AÃ§Ãµes da pÃ¡gina e da tabela.
   */
  @Input('t-actions') set actions(value: ThfPageDynamicTableActions) {
    this._actions = value && typeof value === 'object' && Object.keys(value).length > 0 ? value : {};

    this.setPageActions(this.actions);
    this.setRemoveAllAction();
    this.setTableActions(this.actions);
  }

  get actions(): ThfPageDynamicTableActions {
    return this._actions;
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private thfDialogService: ThfDialogService,
    private thfNotification: ThfNotificationService,
    private thfPageDynamicService: ThfPageDynamicService
    ) {
    super();
  }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.data.serviceApi) {
      this.serviceApi = this.activatedRoute.snapshot.data.serviceApi;

      this.thfPageDynamicService.configServiceApi({ endpoint: this.serviceApi });

      this.loadMetadata();
    } else {
      this.thfPageDynamicService.configServiceApi({ endpoint: this.serviceApi });

      this.loadData();
    }
  }

  onAdvancedSearch(filter) {
    this.loadData({ page: 1, ...filter });
    this.params = filter;
  }

  onChangeDisclaimers(disclaimers) {
    const filter = {};

    disclaimers.forEach(disclaimer => {
      filter[disclaimer.property] = disclaimer.value;
    });

    this.onAdvancedSearch(filter);
  }

  onQuickSearch(filter) {
    this.loadData(filter ? { page: 1, search: filter } : undefined);
    this.params = filter ? { search: filter } : {};
  }

  showMore() {
    this.loadData({ page: ++this.page, ...this.params });
  }

  get hasActionRemoveAll() {
    return !!this.actions.removeAll;
  }

  get pageActions() {
    return [...this._pageActions];
  }

  get tableActions() {
    return this._tableActions;
  }

  private confirmRemove(item) {
    const confirmOptions: ThfDialogConfirmOptions = {
      title: this.literals.confirmRemoveTitle,
      message: this.literals.confirmRemoveMessage,
      confirm: this.remove.bind(this, item)
    };

    this.thfDialogService.confirm(confirmOptions);
  }

  private confirmRemoveAll() {
    const confirmOptions: ThfDialogConfirmOptions = {
      title: this.literals.confirmRemoveAllTitle,
      message: this.literals.confirmRemoveAllMessage,
      confirm: this.removeAll.bind(this)
    };

    this.thfDialogService.confirm(confirmOptions);
  }

  private formatUniqueKey(item) {
    const keys = util.mapObjectByProperties(item, this.keys);

    return util.valuesFromObject(keys).join('|');
  }

  private loadData(params: { page?: number, search?: string } = {}) {
    if (!this.serviceApi) {
      this.thfNotification.error(this.literals.loadDataErrorNotification);
      return;
    }

    const defaultParams: any = { page: 1, pageSize: 10 };
    const fullParams: any = { ...defaultParams, ...params };

    this.thfPageDynamicService.getResources(fullParams).toPromise().then((response: any) => {
      this.items = fullParams.page === 1 ? response.items : [...this.items, ...response.items];
      this.page = fullParams.page;
      this.hasNext = response.hasNext;
    });
  }

  private loadMetadata() {
    this.thfPageDynamicService.getMetadata().toPromise().then(response => {
      this.autoRouter = response.autoRouter;
      this.actions = response.actions || {};
      this.breadcrumb = response.breadcrumb || { items : [] };
      this.fields = response.fields || [];
      this.title = response.title;

      this.loadData();
    });
  }

  // @todo Validar rotas na mÃ£o pois se existir uma rota '**' o catch do navigation nÃ£o funciona.
  private navigateTo(route: {path: string, component?, url?: string, params?: any}, forceStopAutoRouter: boolean = false) {
    this.router.navigate([route.url || route.path], { queryParams: route.params })
      .catch(() => {
        if (forceStopAutoRouter || !this.autoRouter) {
          return;
        }

        this.router.config.unshift(<Route>{
          path: route.path, component: route.component,  data: { serviceApi: this.serviceApi, autoRouter: true }
        });

        this.navigateTo(route, true);
      });
  }

  private openDetail(path: string, item) {
    const url = this.resolveUrl(item, path);

    this.navigateTo({ path, url, component: ThfPageDynamicDetailComponent });
  }

  private openDuplicate(path: string, item) {
    const duplicates = util.mapObjectByProperties(item, this.duplicates);

    this.navigateTo({ path, params: { duplicate: JSON.stringify(duplicates) } });
    // this.navigateTo({ path, params: { duplicate: JSON.stringify(duplicates) } , component: ThfPageDynamicEditComponent });
  }

  private openEdit(path: string, item) {
    const url = this.resolveUrl(item, path);

    this.navigateTo({ path, url });
    // this.navigateTo({ path, url, component: ThfPageDynamicEditComponent });
  }

  private openNew(path: string) {
    this.navigateTo({ path });
    // this.navigateTo({ path, component: ThfPageDynamicEditComponent });
  }

  /**
   * Caso exista mais de um identificador, serÃ¡ concatenado com '|'.
   *
   * Ex: { id: 1, company: 'totvs' }
   *
   * Para o endpoint /resources/:id serÃ¡ executada a url /resources/1|totvs
   */
  private remove(item) {
    const uniqueKey = this.formatUniqueKey(item);

    this.thfPageDynamicService.deleteResource(uniqueKey).toPromise().then(() => {
      this.removeLocalItems([item]);

      this.thfNotification.success(this.literals.removeSuccessNotification);
    });
  }

  private removeAll() {
    // TODO: usar propriedade nova pra validar os itens selecionados
    const selectedItems = this.items.filter(item => item.$selected);

    if (selectedItems.length === 0) {
      // TODO: usar propriedade nova pra validar os itens selecionados
      return;
    }

    const keysSelectedItems = util.mapArrayByProperties(selectedItems, this.keys);

    this.thfPageDynamicService.deleteResources(keysSelectedItems).toPromise().then(() => {
      this.removeLocalItems(selectedItems);

      this.thfNotification.success(this.literals.removeAllSuccessNotification);
    });
  }

  private removeLocalItems(items = []) {
    items.forEach(itemRemoved => {
      const indexItemRemoved = this.items.indexOf(itemRemoved);

      this.items.splice(indexItemRemoved, 1);
    });
  }

  private resolveUrl(item: any, path: string) {
    const uniqueKey = this.formatUniqueKey(item);

    return path.replace(/:id/g, uniqueKey);
  }

  private setPageActions(actions: ThfPageDynamicTableActions) {
    if (actions) {
      this._pageActions = [
        { label: this.literals.pageAction, action: this.openNew.bind(this, actions.new), disabled: !this._actions.new },
      ];
    }
  }

  private setRemoveAllAction() {
    if (this._actions.removeAll) {
      this._pageActions.push({
      label: this.literals.pageActionRemoveAll, action: this.confirmRemoveAll.bind(this),
        disabled: !this._actions.removeAll
      });
    }
  }

  private setTableActions(actions: ThfPageDynamicTableActions) {
    if (actions) {
      this._tableActions = [
        { action: this.openDetail.bind(this, actions.detail), label: this.literals.tableActionView, visible: !!this._actions.detail },
        { action: this.openEdit.bind(this, actions.edit), label: this.literals.tableActionEdit, visible: !!this._actions.edit },
        { action: this.openDuplicate.bind(this, actions.duplicate), label: this.literals.tableActionDuplicate,
          visible: !!this._actions.duplicate
        },
        { action: this.confirmRemove.bind(this), label: this.literals.tableActionDelete, separator: true, type: 'danger',
          visible: !!this._actions.remove
        }
      ];
    }
  }

}
